import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// img
import user from "../../../../Assets/images/user2.png";

// css
import styles from "../setting.module.scss";
import { AMDIN_UPDATE, GET_ADMIN_BY_ID } from "../../../../services/ApiCalls";
import { toast } from "react-toastify";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import fileUploader from "../../../../utilities/fileUploader";
import { createObjectURL } from "../../../../utilities/utilies";
import { useDispatch } from "react-redux";
import { profileImageChange } from "../../../../store/actions";

const schema = z.object({
  name: z.string().min(1, { message: "name is required" }),
  email: z
    .string()
    .min(1, { message: "Email is required" })
    .email("Invalid email address"),
});

const PersonalInformation = () => {
  const [adminData, setAdminData] = useState();
  const [image, setImage] = useState(null);
  const [uploadedImage, setUploadedImage] = useState();

  const dispatch = useDispatch();

  const [contactNumber, setContactNUmber] = useState({
    countryCode: "",
    mobileNumber: "",
  });
  const [Error, setError] = useState({
    contactNumber: "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
    values: {
      name: adminData?.name || "",
      email: adminData?.email || "",
    },
  });

  const getAdmin = async () => {
    try {
      const id = localStorage.getItem("_id");
      const res = await GET_ADMIN_BY_ID(id);
      if (res?.data?.status === "success") {
        setAdminData(res?.data?.data);
        setContactNUmber({
          countryCode: res?.data?.data?.countryCode || "",
          mobileNumber: res?.data?.data?.mobileNumber || "",
        });
        // setContactNUmber({
        //   countryCode: "+91",
        //   mobileNumber: "1234567890",
        // });
        setUploadedImage(res?.data?.data?.profileImage || "");
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  const onSubmit = async (data) => {
    if (
      !contactNumber.countryCode.trim() ||
      !contactNumber.mobileNumber.trim()
    ) {
      return setError((p) => ({
        ...p,
        contactNumber: "Phone Number is Required",
      }));
    } else {
      setError((p) => ({ ...p, contactNumber: "" }));
    }

    try {
      let url;
      if (image) {
        url = await fileUploader(image);
        if (!url) {
          return;
        }
      }

      const adminId = localStorage.getItem("_id");

      const res = await AMDIN_UPDATE({
        userId: adminId,
        mobileNumber: contactNumber.mobileNumber,
        countryCode: contactNumber.countryCode,
        ...data,
        ...(url && { profileImage: url }),
      });

      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        dispatch(profileImageChange(url));
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    getAdmin();
  }, []);

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="justify-content-center">
          <Col lg="12" className="my-2">
            <div
              className={`${styles.uploadProfile} text-center position-relative`}
            >
              <div
                className={`${styles.profileImg} mx-auto imgWrp mb-3 rounded-circle`}
                style={{ background: "#F3F3F3" }}
              >
                <img
                  src={
                    (image && createObjectURL(image)) || uploadedImage || user
                  }
                  alt=""
                  className={`img-fluid h-100 w-100 rounded-circle object-fit-cover`}
                />
              </div>
              <label
                className="d-inline-flex align-items-center justify-content-center commonBtn h-auto  text-white px-2   py-1 rounded"
                type="button"
                htmlFor="image"
              >
                <input
                  type="file"
                  className="d-none"
                  id="image"
                  onChange={(e) =>
                    setImage((p) => {
                      return e.target.files[0];
                    })
                  }
                />
                Upload New
              </label>
            </div>
          </Col>
          <Col lg="12" className="my-2">
            <label
              htmlFor=""
              className={`${styles.formLabel} fw-sbold ps-2 ps-lg-3 mb-0 form-label`}
            >
              Name
            </label>
            <input
              type="text"
              placeholder="smith"
              className={`${styles.formControl} form-control`}
              {...register("name")}
            />

            {
              <p className="errorColor">
                {errors?.name && errors?.name?.message}
              </p>
            }
          </Col>
          <Col lg="12" className="my-2">
            <label
              htmlFor=""
              className={`${styles.formLabel} fw-sbold ps-2 ps-lg-3 mb-0 form-label`}
            >
              Mobile Number
            </label>
            <PhoneInput
              country={"us"}
              value={`${contactNumber.countryCode}Code, "+" + ${contactNumber.mobileNumber}`}
              onChange={(mobileNumber, { dialCode }) => {
                setContactNUmber((p) => ({
                  countryCode: dialCode,
                  mobileNumber: mobileNumber.replace(dialCode, ""),
                }));
              }}
            />
            {
              <p className="errorColor">
                {Error?.contactNumber && Error.contactNumber}
              </p>
            }
          </Col>
          <Col lg="12" className="my-2">
            <label
              htmlFor=""
              className={`${styles.formLabel} fw-sbold ps-2 ps-lg-3 mb-0 form-label`}
            >
              E-Mail ID
            </label>
            <input
              type="email"
              placeholder="smith"
              className={`${styles.formControl} form-control`}
              {...register("email")}
            />
            {
              <p className="errorColor">
                {errors?.email && errors?.email?.message}
              </p>
            }
          </Col>
          <Col lg="8" className="my-2 py-4">
            <Button
              className="d-flex align-items-center justify-content-center w-100 commonBtn"
              type="submit"
            >
              Save
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default PersonalInformation;
